import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  boxContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  mainGrid: {
    width: "100%",
  },
  title: {
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    color: "#101828",
    margin: 0,
  },
}));

export const DangerContainer = styled(Box)({
  width: "100%",
  padding: "16px",
  backgroundColor: "#FEF3F2",
  borderRadius: "8px",
  border: "1px solid #FECDCA",
});

export const InfoContainer = styled(Box)({
  width: "100%",
  padding: "16px",
  backgroundColor: "#F0F9FF",
  borderRadius: "8px",
  border: "1px solid #B9E6FE",
});

export const ErrorContent = styled(Box)({
  display: "flex",
  gap: "12px",
  alignItems: "flex-start",
});

export const InfoContent = styled(Box)({
  display: "flex",
  gap: "12px",
  alignItems: "flex-start",
});

export const ErrorIconContainer = styled(Box)({
  minWidth: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const InfoIconContainer = styled(Box)({
  minWidth: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const ErrorIcon = styled("img")({
  width: "20px",
  height: "20px",
});

export const InfoIcon = styled("img")({
  width: "20px",
  height: "20px",
});

export const ErrorTextContainer = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

export const ErrorText = styled(Typography)({
  fontSize: "14px",
  lineHeight: "20px",
  color: "#D92D20",
});

export const DeliveryChip = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  padding: "2px 8px",
  borderRadius: "12px",
  backgroundColor: "#E0F2FE",
  color: "#0369A1",
  fontSize: "12px",
  fontWeight: 500,
  marginRight: "4px",
}));

export default useStyles;
